<template>
  <div class="ExamsReports">
    <h1 class="text-center my-7">گزارشات آزمون های برگزار شده</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <h4 class="mb-5">گزارش تعداد آزمون های برگزار شده بر اساس استان</h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="stateSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="stateHeaders"
              :items="states"
              :search="stateSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
              <template v-slot:[`item._id`]="{ item }">
                <v-btn
                  outlined
                  depressed
                  color="primary"
                  router
                  :to="{
                    name: 'ExamStateReports',
                    params: { id: item._id }
                  }"
                >
                  مشاهده آزمون های برگزار شده در این استان به تفکیک شهرستان
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="700"
          class="mb-10"
          :options="stateChartOptions"
          :series="stateChartSeries"
        />
        <h4 class="mb-5">گزارش تعداد آزمون های برگزار شده بر اساس کتاب</h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="bookSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="bookHeaders"
              :items="books"
              :search="bookSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="700"
          class="mb-10"
          :options="bookChartOptions"
          :series="bookChartSeries"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "../_Navigation.vue";

export default {
  name: "exams-reports-component",
  components: {
    Navigation
  },
  data() {
    return {
      loading: false,
      stateHeaders: [
        { text: "استان", value: "name", align: "center" },
        { text: "تعداد آزمون برگزار شده", value: "count", align: "center" },
        { text: "اقدامات", value: "_id", align: "center" }
      ],
      states: [],
      stateSearch: "",
      bookHeaders: [
        { text: "نام کتاب", value: "title", align: "center" },
        { text: "مقطع", value: "grade", align: "center" },
        { text: "کتاب شماره", value: "level", align: "center" },
        { text: "تعداد آزمون برگزار شده", value: "count", align: "center" }
      ],
      books: [],
      bookSearch: "",
      stateChartSeries: [
        {
          name: "نمره کل",
          data: []
        },
        {
          name: "تمرکز",
          data: []
        },
        {
          name: "استنباط",
          data: []
        },
        {
          name: "تفسیر",
          data: []
        },
        {
          name: "ارزیابی",
          data: []
        }
      ],
      bookChartSeries: [
        {
          name: "نمره کل",
          data: []
        },
        {
          name: "تمرکز",
          data: []
        },
        {
          name: "استنباط",
          data: []
        },
        {
          name: "تفسیر",
          data: []
        },
        {
          name: "ارزیابی",
          data: []
        }
      ],
      stateChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس استان",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10,
          min: 0,
          max: 100
        }
      },
      bookChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس کتاب",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10,
          min: 0,
          max: 100
        }
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api
        .get("answersheets/reports")
        .then((res) => {
          const data = res.data;

          // state
          data.states.forEach((element) => {
            this.stateChartSeries[0].data.push(element.totalScore.toFixed(1));
            this.stateChartSeries[1].data.push(element.focusScore.toFixed(1));
            this.stateChartSeries[2].data.push(
              element.inferenceScore.toFixed(1)
            );
            this.stateChartSeries[3].data.push(
              element.interpretationScore.toFixed(1)
            );
            this.stateChartSeries[4].data.push(
              element.assessmentScore.toFixed(1)
            );
            this.stateChartOptions.xaxis.categories.push(element.name);
          });

          // book
          data.books.forEach((element) => {
            this.bookChartSeries[0].data.push(element.totalScore.toFixed(1));
            this.bookChartSeries[1].data.push(element.focusScore.toFixed(1));
            this.bookChartSeries[2].data.push(
              element.inferenceScore.toFixed(1)
            );
            this.bookChartSeries[3].data.push(
              element.interpretationScore.toFixed(1)
            );
            this.bookChartSeries[4].data.push(
              element.assessmentScore.toFixed(1)
            );
            this.bookChartOptions.xaxis.categories.push(element.title);
          });

          this.books = data.books;
          this.states = data.states;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.ExamsReports .apexcharts-xaxis-texts-g {
  transform: translate(0, 95px);
}
.ExamsReports .apexcharts-yaxis {
  transform: translate(-97%, 0);
}
@media only screen and (max-width: 600px) {
  .ExamsReports .apexcharts-xaxis-texts-g {
    transform: translate(0, 95px);
  }
}
</style>
